import React, { useState } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';

import { ISubAnalysis } from 'interfaces/Pricelist/ISubAnalysis';
import SubAnalysisDetails from './SubAnalysisDetails';
import './SubAnalysisCell.scss';

const SubAnalysisCell = (detailData: ISubAnalysis) => {
  const [showSubAnalysisPopup, setShowSubAnalysisPopup] = useState(false);

  return detailData ? (
    <>
      <Box className="subAnalysisButton">
        <Button onClick={() => setShowSubAnalysisPopup(true)}>
          <VisibilityIcon /> Analytes
        </Button>
      </Box>

      <Dialog open={showSubAnalysisPopup} maxWidth="lg" onClose={() => setShowSubAnalysisPopup(false)}>
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <Box flexGrow={1}>Analytes</Box>
            <Box>
              <IconButton onClick={() => setShowSubAnalysisPopup(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          <SubAnalysisDetails {...detailData} />
        </DialogContent>
      </Dialog>
    </>
  ) : (
    <p>N/A</p>
  );
};

export default React.memo(SubAnalysisCell);
